import { getConfig } from "./config";

const getHeaders = () => ({
  "Content-Type": "application/json",
});

export const bookAppointment = async (formData) => {
  try {
    const config = await getConfig();

    const payload = {
      patient: {
        patientName: formData.patientName,
        age: Number(formData.patientAge),
        gender: formData.gender,
        mobileNumber: formData.mobile,
        email: "",
        symptoms: formData.notes,
      },

      address:
        formData.bookingType === "home"
          ? {
              addressLine: formData.addressLine,
              locality: formData.locality,
              city: formData.city,
              pincode: formData.pincode,
            }
          : null,

      serviceRequest: {
        consultationType:
          formData.bookingType === "home"
            ? "Home Visit"
            : "Daily Consultation",

        consultantName: formData.specialist,
        department: formData.department,

        appointmentDate: formData.date || null,
        appointmentTime: formData.slot || null,

        consultationMode: formData.consultationMode,
        preferredVisitTiming: formData.visitTiming,
        doctorType: formData.doctorId,

        emergencyRequest: formData.emergency,
        visitPrice: Number(formData.visitPrice),
      },
    };

    const res = await fetch(
      `${config.baseUrl}${config.booking.bookAppointment}`,
      {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(payload),
      }
    );

    return await res.json();
  } catch (error) {
    return {
      Success: false,
      Message: error.message,
    };
  }
};

export const getBookings = async () => {
  try {
    const config = await getConfig();

    const res = await fetch(
      `${config.baseUrl}${config.booking.getBookings}`,
      {
        method: "GET",
        headers: getHeaders(),
      }
    );

    return await res.json();
  } catch (error) {
    return {
      Success: false,
      Message: error.message,
    };
  }
};


